/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface mobileLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface authenticatedLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export default interface FooterLink {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  pageLink ? : any;
  intLinkParam ? : string;
  mobileLink ? : Array < mobileLinkStruct > ;
  authenticatedLink ? : Array < authenticatedLinkStruct > ;
  emphasis ? : boolean;
  openCookies ? : boolean;
  showLinkKiosk ? : boolean;
  showLinkCatalog ? : boolean;
  showLinkLoyalty ? : boolean;
  metadata ? : any;
}

export const Props = {
  switchable: Object as() => switchableStruct,
  linkTargetMode: String,
  title: String,
  pageLink: Object,
  intLinkParam: String,
  mobileLink: Array as() => Array < mobileLinkStruct > ,
  authenticatedLink: Array as() => Array < authenticatedLinkStruct > ,
  emphasis: Boolean,
  openCookies: Boolean,
  showLinkKiosk: Boolean,
  showLinkCatalog: Boolean,
  showLinkLoyalty: Boolean,
  metadata: Object,
}

export const WrapperProps = {
  switchable: Object as() => switchableStruct,
  linkTargetMode: String,
  title: String,
  pageLink: Object,
  intLinkParam: String,
  mobileLink: Object,
  authenticatedLink: Object,
  emphasis: Boolean,
  openCookies: Boolean,
  showLinkKiosk: Boolean,
  showLinkCatalog: Boolean,
  showLinkLoyalty: Boolean,
  metadata: Object,
}

export class FooterLinkBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class FooterLinkInstance implements FooterLink {
      switchable ? : switchableStruct;
      linkTargetMode ? : string;
      title ? : string;
      pageLink ? : any;
      intLinkParam ? : string;
      mobileLink ? : Array < mobileLinkStruct > ;
      authenticatedLink ? : Array < authenticatedLinkStruct > ;
      emphasis ? : boolean;
      openCookies ? : boolean;
      showLinkKiosk ? : boolean;
      showLinkCatalog ? : boolean;
      showLinkLoyalty ? : boolean;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.switchable) {
          if (typeof this.switchable.download === 'object') {
            this.switchable.download = {
              ...this.switchable.download,
              link: this.switchable.download['@link'],
              name: this.switchable.download['@name'],
              path: this.switchable.download['@path'],
            };
          } else {
            this.switchable.download = null as any;
          }
        }
        if (this.mobileLink) {
          this.mobileLink = Object.entries(this.mobileLink)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileLink' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.mobileLink.length; i1++) {

            if (this.mobileLink[i1]) {
              if (this.mobileLink[i1].switchable) {
                if (typeof this.mobileLink[i1].switchable.download === 'object') {
                  this.mobileLink[i1].switchable.download = {
                    ...this.mobileLink[i1].switchable.download,
                    link: this.mobileLink[i1].switchable.download['@link'],
                    name: this.mobileLink[i1].switchable.download['@name'],
                    path: this.mobileLink[i1].switchable.download['@path'],
                  };
                } else {
                  this.mobileLink[i1].switchable.download = null as any;
                }
              }
            }
          }
        } else {
          this.mobileLink = null as any;
        }
        if (this.authenticatedLink) {
          this.authenticatedLink = Object.entries(this.authenticatedLink)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'authenticatedLink' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.authenticatedLink.length; i1++) {

            if (this.authenticatedLink[i1]) {
              if (this.authenticatedLink[i1].switchable) {
                if (typeof this.authenticatedLink[i1].switchable.download === 'object') {
                  this.authenticatedLink[i1].switchable.download = {
                    ...this.authenticatedLink[i1].switchable.download,
                    link: this.authenticatedLink[i1].switchable.download['@link'],
                    name: this.authenticatedLink[i1].switchable.download['@name'],
                    path: this.authenticatedLink[i1].switchable.download['@path'],
                  };
                } else {
                  this.authenticatedLink[i1].switchable.download = null as any;
                }
              }
            }
          }
        } else {
          this.authenticatedLink = null as any;
        }
      }
    }
    return new FooterLinkInstance(props);
  }
}
